const appData = {
    title: "Honest Applications LLC",
    email: "honestapplicationsmail@gmail.com",
    ffLink: "http://www.flicfuse.com",
};

export default appData;